<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">SESSION VOLUNTEER</h4>
                
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Topics</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Mode</th>
                            <th>Status</th>
                            <th>Show</th>
                        

                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.topics}}
                            </td>

                            <td style="min-width: 20px;">
                                {{customer.start_date | date: 'dd-MM-yyyy'}} -
                                {{customer.end_date | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.start_tiime }} - {{customer.end_time }}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.mode}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.status}}
                            </td>

                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                          
                            <!-- <td><a (click)="handleClickNavigate(customer.id)" class="btn btn-primary btn-sm">
                                    <i class="fas fa-eye"></i>
                                </a><td> -->
                            <ng-template #notShow>
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title">CREATE SESSION VOLUNTEER</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='createmeetingform'
                                (ngSubmit)="postdata(createmeetingform)" autocomplete="off">

                                <input pInputText type="text" class="form-control" formControlName="user_id"
                                    [(ngModel)]="user_id" readonly placeholder="Enter UserId" style="display:none">

                                <div class="form-group row">
                                    <div class="col-sm-12 mb-3">
                                        <label class="form-label">Topics/தலைப்புகள்</label>
                                        <input type="text" formControlName="topics" class="form-control"
                                            placeholder="Enter Topics/தலைப்புகள்" required />
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('topics').touched && createmeetingform.get('topics').value=='')">
                                            Please fill the field</div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Start Date / தொடங்குகிறது தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="start_date" class="form-control"
                                            placeholder="Enter Start Date / தொடங்குகிறது தேதி" required
                                            min="{{date | date:'yyyy-MM-dd'}}">
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('start_date').touched && createmeetingform.get('start_date').value=='')">
                                            Please fill the field</div>
                                        <!-- <div  *ngIf="(createmeetingform.get('meeting_date').touched && createmeetingform.get('meeting_date').value=='')"
                                  class="invalid-msg" >Please fill this field</div> -->
                                        <!-- <div  class="invalid-msg" *ngIf="createmeetingform.get('meeting_date').untouched" [hidden]='hidden'>Please fill this field</div> -->
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Start Time / தொடங்குகிறது நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="start_time"
                                            placeholder="Enter Start Time / தொடங்குகிறது நேரம்" required>
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('start_time').touched && createmeetingform.get('start_time').value=='')">
                                            Please fill
                                            the field</div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>End Date / முடிவு தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="end_date" class="form-control"
                                            placeholder="Enter End Date / முடிவு தேதி" required
                                            min="{{date | date:'yyyy-MM-dd'}}">
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('end_date').touched && createmeetingform.get('end_date').value=='')">
                                            Please fill the field</div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>End Time / முடிவு நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="end_time"
                                            placeholder="Enter End Time / முடிவு நேரம்" required>
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('end_time').touched && createmeetingform.get('end_time').value=='')">
                                            Please fill
                                            the field</div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Mode / பயன்முறை<span class="required "> *</span></label>
                                        <select type="text" class="form-control" formControlName="mode"
                                            placeholder="Mode / பயன்முறை">
                                            <option value="" selected>Select Mode / பயன்முறை
                                            </option>
                                            <option>Offline</option>
                                            <option>Online</option>

                                        </select>
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('mode').touched && createmeetingform.get('mode').value=='')">
                                            Please fill
                                            the field</div>
                                    </div>

                                    <div class="col-sm-6">
                                        <label>Status/ சமுதாயப் படிநிலை <span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required>
                                            <option value="" selected>Select Status/ சமுதாயப் படிநிலை</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>

                                        </select>
                                        <div style="color:red;"
                                            *ngIf="createmeetingform.get('status').touched && createmeetingform.get('status').value==''">
                                            Please fill
                                            the field</div>
                                    </div>
                                </div>
                                <br />


                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block"
                                            [disabled]="!createmeetingform.valid">Create Session Volunteer</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">




                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-12 mb-12 mb-sm-0">
                                        <label class="form-label">Topics/தலைப்புகள்</label>
                                        <input type="text" formControlName="topics" [value]="CM_topics"
                                            class="form-control" placeholder="Enter Topics/தலைப்புகள்" readonly />

                                    </div>

                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Start Date / தொடங்குகிறது தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="start_date" class="form-control"
                                            [value]="CM_start_date" placeholder="Enter Start Date / தொடங்குகிறது தேதி"
                                            readonly>

                                    </div>
                                    <div class="col-sm-6">
                                        <label>Start Time / தொடங்குகிறது நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="start_time"
                                            [value]="CM_start_time" placeholder="Enter Start Time / தொடங்குகிறது நேரம்"
                                            readonly>

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>End Date / முடிவு தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="end_date" class="form-control"
                                            [value]="CM_end_date" placeholder="Enter End Date / முடிவு தேதி" readonly>

                                    </div>
                                    <div class="col-sm-6">
                                        <label>End Time / முடிவு நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="end_time"
                                            [value]="CM_end_time" placeholder="Enter End Time / முடிவு நேரம்" readonly>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Mode / பயன்முறை<span class="required "> *</span></label>
                                        <input type="text" class="form-control" formControlName="mode" [value]="CM_mode"
                                            placeholder="Enter Mode / பயன்முறை" readonly>

                                    </div>
                                    <div class="col-sm-6">
                                        <label>Status/ சமுதாயப் படிநிலை<span class="required "> *</span></label>
                                        <input type="text" class="form-control" formControlName="status" readonly
                                            placeholder="Enter Status" [value]="CM_status">

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-12 mb-12 mb-sm-0">
                                        <label class="form-label">Topics/தலைப்புகள்</label>
                                        <input type="text" formControlName="topics" [value]="CM_topics"
                                            class="form-control" placeholder="Enter Topics/தலைப்புகள்" />

                                    </div>

                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Start Date / தொடங்குகிறது தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="start_date" class="form-control"
                                            [value]="CM_start_date" placeholder="Enter Start Date / தொடங்குகிறது தேதி">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>Start Time / தொடங்குகிறது நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="start_time"
                                            [value]="CM_start_time" placeholder="Enter Start Time / தொடங்குகிறது நேரம்">

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>End Date / முடிவு தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="end_date" class="form-control"
                                            [value]="CM_end_date" placeholder="Enter End Date / முடிவு தேதி">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>End Time / முடிவு நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="end_time"
                                            [value]="CM_end_time" placeholder="Enter End Time / முடிவு நேரம்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Mode / பயன்முறை<span class="required "> *</span></label>
                                        <select type="text" class="form-control" formControlName="mode"
                                            placeholder="Mode / பயன்முறை" [(ngModel)]="CM_mode">
                                            <option value="" selected>Select Mode / பயன்முறை
                                            </option>
                                            <option>Offline</option>
                                            <option>Online</option>

                                        </select>

                                    </div>
                                    <div class="col-sm-6">
                                        <label>Status/ சமுதாயப் படிநிலை<span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" [(ngModel)]="CM_status"
                                            required>
                                            <option value="" selected>Select Status/ சமுதாயப் படிநிலை</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>

                                        </select>


                                    </div>
                                </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block">Update Session Volunteer</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>